import { render, staticRenderFns } from "./AdminProduct.vue?vue&type=template&id=5278af9a&scoped=true&"
import script from "./AdminProduct.vue?vue&type=script&lang=js&"
export * from "./AdminProduct.vue?vue&type=script&lang=js&"
import style0 from "./AdminProduct.vue?vue&type=style&index=0&id=5278af9a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5278af9a",
  null
  
)

export default component.exports